import { AxiosResponse } from 'axios';
import { DataTransfer } from '@esmiley/frontend-core';
import {
  MonthlyReport,
  MonthlyReportsApiResponse,
  MonthlyReportsQueryParams,
  SendSummary
} from './types';

const transfer = new DataTransfer();

export async function fetchMonthlyReports(
  params: MonthlyReportsQueryParams
): Promise<MonthlyReportsApiResponse> {
  const query = new URLSearchParams({
    limit: String(params.limit),
    skip: String(params.skip),
    date: params.date,
    ...(params.sort ? { sort: params.sort } : {}),
    ...(params.accountId ? { accountId: params.accountId } : {}),
    ...(params.accountName ? { accountName: params.accountName } : {}),
    ...(params.partner ? { partner: params.partner } : {})
  });

  const response = (await transfer.get(
    `/foodwaste/admin/monthly-reports/reports?${query.toString()}`
  )) as AxiosResponse<MonthlyReportsApiResponse>;

  return response.data;
}

export async function sendMonthlyReportEmail(
  accountId: string,
  reportId: MonthlyReport['id']
): Promise<SendSummary> {
  const response = (await transfer.post(
    `/foodwaste/admin/accounts/${accountId}/monthly-reports/${reportId}/email`,
    {}
  )) as AxiosResponse<SendSummary>;

  return response.data;
}
